import apiClient from '@/services/axios'

export async function post(calendarEntry) {
  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setup-calendar-entries/', calendarEntry);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post calendar entry.')
}
